var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g2, _path23, _g3, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgRewardBox = function SvgRewardBox(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 211,
    height: 183,
    fill: "none",
    viewBox: "0 0 211 183",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    d: "M101.524 104.736 43.48 138.833a3.43 3.43 0 0 0-1.71 2.988c0 1.17.58 2.341 1.74 3.007l58.1 33.341a6.93 6.93 0 0 0 6.833.038l59.184-33.092a3.43 3.43 0 0 0 1.774-3.026 3.43 3.43 0 0 0-1.724-2.995l-59.159-34.375a6.93 6.93 0 0 0-6.994.017"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    d: "M108.517 74.354a6.93 6.93 0 0 0-6.993.017v30.363a6.93 6.93 0 0 1 6.993-.017zM167.676 108.73l-59.159-34.374v30.362l59.159 34.375z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    fillRule: "evenodd",
    d: "m43.48 108.47 58.044-34.097v30.362L43.48 138.833zm0 .002a3.43 3.43 0 0 0-1.71 2.987v30.363c0-1.159.57-2.318 1.71-2.988z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    d: "M169.351 111.686a3.43 3.43 0 0 0-1.724-2.996v30.363a3.43 3.43 0 0 1 1.724 2.995z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#70BAFF",
    fillRule: "evenodd",
    d: "m43.51 144.825 58.1 33.341v-30.362l-58.1-33.342v.001a3.43 3.43 0 0 1-1.74-3.005v30.361c0 1.171.58 2.342 1.74 3.007z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m101.61 178.166-.111.194a.224.224 0 0 0 .334-.194zm-58.1-33.341.111-.193a.222.222 0 0 0-.334.193zm58.1 2.979h.223a.23.23 0 0 0-.112-.194zm-58.1-33.342.111-.193a.223.223 0 0 0-.334.182zm0 .001-.11.194a.223.223 0 0 0 .334-.182zm-1.74-3.005h.223a.223.223 0 0 0-.446 0zm0 30.361h.223zm1.74 3.007-.11.193a.222.222 0 0 0 .333-.193zm58.1 33.34.111-.193-58.1-33.341-.11.193-.111.193 58.099 33.342zm0-30.362h-.223v30.362h.446v-30.362zm-58.1-33.342-.11.194 58.099 33.341.111-.193.111-.194-58.1-33.341zm0 .001.223.012v-.001zl-.222-.011v.001zm0 0 .111-.193a3.21 3.21 0 0 1-1.628-2.812h-.446c0 1.244.618 2.491 1.852 3.199zm-1.74-3.005h-.223v30.361h.446v-30.361zm0 30.361h-.223c0 1.245.618 2.492 1.853 3.2l.11-.193.111-.193a3.21 3.21 0 0 1-1.628-2.814zm1.74 3.007h.223v-.001h-.446v.001zm-1.74-33.369h-.223v.001h.446v-.001z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#000",
    strokeWidth: 0.446,
    d: "M63.41 156.249v-30.262l11.891 6.84v30.249z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#CEE7FF",
    fillRule: "evenodd",
    d: "M167.573 114.702a3.43 3.43 0 0 0 1.774-3.025v30.361a3.43 3.43 0 0 1-1.773 3.025v.001l-59.183 33.091v-.012l-.002.015a6.93 6.93 0 0 1-6.833-.038v-30.362a6.94 6.94 0 0 0 6.833.038l.002.015v-.018z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M169.347 111.677h.223a.223.223 0 1 0-.446 0zm-1.774 3.025-.109-.195a.23.23 0 0 0-.114.195zm1.774 27.336h-.223zm-1.773 3.025-.109-.194a.23.23 0 0 0-.113.18zm0 .001.109.194a.22.22 0 0 0 .114-.18zm-59.183 33.091h-.223a.223.223 0 0 0 .331.195zm0-.012h.223a.223.223 0 0 0-.446-.018zm-.002.015.109.195a.23.23 0 0 0 .114-.178zm-6.833-.038h-.223c0 .08.043.154.112.193zm0-30.362.111-.194a.223.223 0 0 0-.334.194zm6.833.038.223-.018a.223.223 0 0 0-.331-.177zm.002.015-.223.017a.224.224 0 0 0 .446-.017zm0-.018-.109-.195a.22.22 0 0 0-.114.195zm59.182-33.091.109.195a.23.23 0 0 0 .114-.195zm1.774-3.025h-.223a3.21 3.21 0 0 1-1.66 2.83l.109.195.109.194a3.66 3.66 0 0 0 1.888-3.219zm0 30.361h.223v-30.361h-.446v30.361zm-1.773 3.025.109.195a3.65 3.65 0 0 0 1.887-3.22h-.446a3.21 3.21 0 0 1-1.659 2.831zm0 .001.223.014-.223-.015-.222-.014zm-59.183 33.091.108.195 59.184-33.092-.109-.194-.109-.195-59.183 33.092zm0-.012h-.223v.012h.446v-.012zm0 0-.223-.018-.001.016.222.017.223.017.001-.015zm-.002.015-.108-.194a6.71 6.71 0 0 1-6.614-.037l-.111.193-.111.193a7.15 7.15 0 0 0 7.053.04zm-6.833-.038h.223v-30.362h-.446v30.362zm0-30.362-.111.193a7.16 7.16 0 0 0 7.053.039l-.109-.194-.108-.195a6.71 6.71 0 0 1-6.614-.037zm6.833.038-.222.017.001.015.223-.017.222-.018-.001-.015zm.002-.003h-.223v.018h.446v-.018zm59.182-33.091-.109-.195-59.182 33.091.109.195.108.194 59.183-33.09zm0 0h-.223zh.223zm1.774-3.027h-.223v.002h.446v-.002z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#000",
    strokeWidth: 0.446,
    d: "M144.84 157.865v-30.204l-11.892 6.84v30.022z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "reward-box_svg__a",
    width: 57,
    height: 48,
    x: 41,
    y: 88,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "m48.751 117.183 30.953 17.942 7.67-3.013 3.56-10.409 6.848-19.174-20.817-8.355-23.694-5.478-12.053 9.176z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#reward-box_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B0FFE9",
    stroke: "#111",
    strokeWidth: 0.263,
    d: "M48.934 96.839c-6.113 6.261-1.525 18.264 8.763 27.538 10.285 9.272 23.954 10.375 28.748 5.143 5.635-6.151 2.303-17.589-7.983-26.864-9.175-8.27-23.674-11.815-29.528-5.817Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 0.263,
    d: "M57.638 124.438c-5.155-4.649-8.89-9.986-10.566-14.952-1.677-4.968-1.297-9.568 1.783-12.723 2.953-3.023 8.075-3.635 13.597-2.46s11.462 4.138 16.068 8.29c10.31 9.296 13.685 20.8 8.006 26.998-2.418 2.64-7.066 3.674-12.386 2.89-5.324-.783-11.336-3.388-16.5-8.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50AF95",
    fillRule: "evenodd",
    stroke: "#111",
    strokeWidth: 0.263,
    d: "M81.112 128.274c1.293-.385 2.367-1 3.133-1.837 4.488-4.899 1.375-14.423-7.443-22.373-7.864-7.09-20.002-10.444-24.675-5.679-4.868 4.962-.73 14.948 8.036 22.885 6.992 6.278 15.605 8.411 20.949 7.004Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    fillRule: "evenodd",
    d: "M60.114 121.22c-8.984-8.1-13.17-18.393-8.095-23.574 4.861-4.963 17.312-1.634 25.327 5.591 8.984 8.1 12.084 17.886 7.414 22.984-.879.959-2.135 1.644-3.653 2.045 1.296-.385 2.368-1.001 3.136-1.838 4.489-4.898 1.374-14.424-7.442-22.373-7.864-7.09-20.002-10.444-24.676-5.679-4.876 4.972-.714 14.988 8.09 22.934q-.05-.045-.1-.089z",
    clipRule: "evenodd"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0FFE9",
    stroke: "#111",
    strokeWidth: 0.263,
    d: "M168.45 89.181c4.185 7.884-3.806 17.462-16.601 22.573-12.794 5.11-26.538 1.492-29.727-4.99-3.749-7.619 2.845-17.1 15.639-22.211 11.412-4.558 26.68-2.924 30.689 4.628Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 0.263,
    d: "M151.888 111.831c6.413-2.562 11.63-6.247 14.718-10.284 3.089-4.04 4.051-8.437 1.942-12.409-2.022-3.807-6.875-6.114-12.639-6.899s-12.458-.052-18.187 2.236c-12.825 5.124-19.479 14.65-15.701 22.328 1.609 3.27 5.873 5.808 11.325 6.887 5.456 1.081 12.117.706 18.539-1.86z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#50AF95",
    fillRule: "evenodd",
    stroke: "#111",
    strokeWidth: 0.263,
    d: "M127.721 107.42c-1.159-.797-2.035-1.732-2.544-2.769-2.986-6.068 2.837-13.846 13.804-18.228 9.782-3.908 22.676-2.899 25.883 3.109 3.34 6.256-3.623 14.115-14.536 18.503-8.689 3.45-17.768 2.504-22.607-.615Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    fillRule: "evenodd",
    d: "M150.391 108.004c11.175-4.465 18.274-12.593 14.793-19.123-3.333-6.254-16.527-7.393-26.496-3.411-11.175 4.464-17.061 12.49-13.954 18.805.584 1.188 1.619 2.25 2.994 3.138-1.161-.798-2.035-1.733-2.547-2.771-2.986-6.068 2.839-13.847 13.805-18.228 9.782-3.908 22.676-2.899 25.882 3.11 3.346 6.267-3.65 14.146-14.603 18.529l.123-.05z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0FFE9",
    stroke: "#111",
    strokeWidth: 0.263,
    d: "M149.038 98.435c5.675 6.89-.243 17.87-11.761 25.432-11.517 7.56-25.707 6.758-30.125 1.043-5.194-6.717-.625-17.323 10.892-24.886 10.272-6.743 25.559-8.189 30.994-1.59Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 0.263,
    d: "M137.33 123.934c5.773-3.79 10.15-8.441 12.37-13.014 2.22-4.575 2.286-9.075-.574-12.547-2.741-3.327-7.957-4.619-13.761-4.237-5.805.38-12.218 2.435-17.375 5.82-11.544 7.581-16.164 18.244-10.929 25.013 2.229 2.883 6.915 4.518 12.472 4.488 5.562-.03 12.014-1.727 17.795-5.523z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#50AF95",
    fillRule: "evenodd",
    stroke: "#111",
    strokeWidth: 0.263,
    d: "M112.769 124.436c-1.294-.549-2.338-1.291-3.045-2.205-4.137-5.35.016-14.134 9.889-20.617 8.805-5.782 21.641-7.366 25.982-2.12 4.522 5.464-.732 14.555-10.551 21.033-7.825 5.115-16.91 6-22.275 3.909Z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    fillRule: "evenodd",
    d: "M135.1 120.482c10.059-6.604 15.393-15.986 10.679-21.69-4.514-5.463-17.671-3.946-26.644 1.946-10.059 6.604-14.224 15.644-9.92 21.211.81 1.048 2.036 1.883 3.56 2.478-1.297-.55-2.34-1.292-3.048-2.207-4.137-5.35.017-14.135 9.888-20.617 8.805-5.781 21.642-7.366 25.983-2.119 4.529 5.474-.753 14.591-10.612 21.071l.112-.073z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0FFE9",
    stroke: "#111",
    strokeWidth: 0.263,
    d: "M65.51 98.617c-6.506 7.871.194 19.526 13.298 27.111 13.103 7.583 29.294 5.863 34.361-.649 5.956-7.654.794-18.98-12.309-26.566-11.688-6.764-29.12-7.436-35.35.104Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 0.263,
    d: "M78.747 125.806c-6.568-3.802-11.539-8.628-14.05-13.496-2.512-4.871-2.566-9.788.712-13.754 3.143-3.8 9.1-5.523 15.719-5.451 6.62.07 13.927 1.937 19.793 5.332 13.134 7.603 18.354 18.989 12.351 26.702-2.556 3.285-7.909 5.352-14.248 5.649-6.345.297-13.697-1.175-20.275-4.982z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#50AF95",
    fillRule: "evenodd",
    stroke: "#111",
    strokeWidth: 0.263,
    d: "M106.763 124.894c1.479-.677 2.674-1.55 3.484-2.592 4.744-6.096.047-15.455-11.184-21.957-10.018-5.8-24.654-6.769-29.63-.773-5.184 6.242.767 15.871 11.937 22.371 8.904 5.128 19.263 5.556 25.393 2.951Z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    fillRule: "evenodd",
    d: "M81.307 121.9c-11.444-6.625-17.485-16.567-12.081-23.084 5.175-6.242 20.176-5.365 30.386.544 11.444 6.625 16.153 16.262 11.217 22.606-.928 1.194-2.331 2.179-4.072 2.92 1.481-.678 2.675-1.552 3.487-2.593 4.744-6.097.046-15.456-11.184-21.958-10.018-5.799-24.654-6.768-29.63-.773-5.193 6.255.79 15.91 12.007 22.411l-.127-.073z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "reward-box_svg__b",
    width: 63,
    height: 36,
    x: 72,
    y: 113,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M134.624 132.796s-23.851 14.037-27.402 15.266c-1.019.353-2.867.682-5.462-.41-7.647-4.233-22.531-12.973-22.531-12.973l-6.282-16.386 30.998-4.507z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#reward-box_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B0FFE9",
    stroke: "#111",
    strokeWidth: 0.381,
    d: "M84.222 129.326c-5.811 10.067 3.48 24.569 19.104 33.79 15.624 9.219 33.075 6.653 37.537-1.668 5.245-9.78-2.305-23.906-17.929-33.128-13.936-8.223-33.147-8.637-38.712 1.006Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 0.381,
    d: "M103.272 163.215c-7.832-4.622-14.085-10.573-17.651-16.638-3.567-6.067-4.447-12.254-1.52-17.326 2.808-4.862 9.045-7.177 16.309-7.25 7.266-.075 15.583 2.092 22.578 6.22 15.661 9.243 23.284 23.443 17.998 33.299-2.252 4.198-7.77 6.931-14.666 7.462-6.902.531-15.202-1.139-23.046-5.767z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50AF95",
    fillRule: "evenodd",
    stroke: "#111",
    strokeWidth: 0.381,
    d: "M133.814 161.374c1.507-.89 2.67-2.018 3.383-3.349 4.178-7.789-2.533-19.451-15.926-27.356-11.945-7.05-28.142-7.908-32.592-.239-4.635 7.985 3.496 19.956 16.821 27.858 10.613 6.234 22.034 6.516 28.314 3.086Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    fillRule: "evenodd",
    d: "M105.424 158.235c-13.647-8.053-21.928-20.415-17.098-28.751 4.626-7.984 21.208-7.252 33.381-.068 13.647 8.053 20.418 20.065 16.071 28.171-.817 1.525-2.189 2.8-3.973 3.776 1.51-.89 2.671-2.019 3.387-3.35 4.178-7.79-2.535-19.453-15.926-27.357-11.945-7.049-28.142-7.907-32.592-.239-4.643 8.001 3.528 20.004 16.904 27.907l-.152-.089z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "reward-box_svg__c",
    width: 60,
    height: 44,
    x: 109,
    y: 99,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m161.976 117.447-30.725 17.206-13.747 7.867-7.67-12.326 2.573-14.659 33.729-16.386 22.316 4.749z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#reward-box_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B0FFE9",
    stroke: "#111",
    strokeWidth: 0.263,
    d: "M157.255 107.949c5.675 6.89-.243 17.87-11.761 25.432s-25.707 6.759-30.125 1.044c-5.194-6.718-.625-17.323 10.892-24.886 10.272-6.744 25.559-8.189 30.994-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 0.263,
    d: "M145.547 133.449c5.773-3.791 10.15-8.442 12.37-13.015 2.22-4.575 2.285-9.075-.574-12.546-2.741-3.327-7.957-4.619-13.761-4.238-5.805.381-12.219 2.435-17.375 5.821-11.544 7.58-16.164 18.243-10.929 25.013 2.229 2.883 6.915 4.518 12.472 4.487 5.562-.03 12.013-1.727 17.795-5.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50AF95",
    fillRule: "evenodd",
    stroke: "#111",
    strokeWidth: 0.263,
    d: "M120.986 133.95c-1.294-.549-2.339-1.291-3.045-2.205-4.137-5.35.016-14.134 9.889-20.617 8.805-5.782 21.641-7.366 25.982-2.119 4.522 5.463-.733 14.554-10.551 21.032-7.825 5.115-16.91 6-22.275 3.909Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    fillRule: "evenodd",
    d: "M143.317 129.998c10.059-6.605 15.393-15.987 10.679-21.69-4.515-5.464-17.671-3.946-26.644 1.945-10.059 6.605-14.224 15.644-9.92 21.212.81 1.048 2.035 1.882 3.56 2.477-1.297-.549-2.34-1.292-3.049-2.206-4.136-5.35.018-14.135 9.889-20.617 8.805-5.782 21.641-7.366 25.983-2.119 4.529 5.474-.754 14.59-10.612 21.071l.111-.073z",
    clipRule: "evenodd"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#70BAFF",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.432,
    d: "M108.41 34.416a6.97 6.97 0 0 0-7.029.024l.016 17.418a6.97 6.97 0 0 1 7.029-.024z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#70BAFF",
    d: "M41.596 71.565a.22.22 0 0 1 .22.003l59.834 36.493c.064.039.104.11.104.185l.017 17.418a.22.22 0 0 1-.11.187.21.21 0 0 1-.216 0L42.141 90.92a.22.22 0 0 1-.106-.18l-.547-18.982a.22.22 0 0 1 .108-.193"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m41.596 71.565-.108-.187zm.22.003.113-.185zm59.834 36.493.113-.184zm.104.185h.216v-.001zm-.093 17.605.108.188zm-.216 0-.11.186zM42.141 90.92l-.11.186zm-.106-.18.216-.007zm-.547-18.982-.216.006zm.108-.193.108.187.112-.184.113-.185a.43.43 0 0 0-.442-.005zm.22.003-.112.184 59.834 36.494.112-.185.113-.184-59.834-36.494zm59.834 36.493-.112.185h.216l.216-.001c0-.15-.079-.29-.207-.368zm.104.185h-.216l.016 17.418h.217l.216-.001-.017-17.417zm.017 17.418h-.217l.107.187.108.188a.44.44 0 0 0 .218-.376zm-.11.187-.107-.187-.109.187-.11.186c.135.079.3.078.434.002zm-.216 0 .109-.187-59.304-34.93-.11.186-.11.186 59.305 34.931zM42.141 90.92l.11-.186-.216.005-.216.007a.43.43 0 0 0 .212.36zm-.106-.18.216-.007-.546-18.98-.217.005-.216.007.547 18.98zm-.547-18.982.217-.005v-.001l-.11-.187-.108-.187a.43.43 0 0 0-.215.386z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F4",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.432,
    d: "M101.379 34.44 43.071 68.766c-2.304 1.357-2.284 4.696.037 6.025l58.428 33.456a6.97 6.97 0 0 0 6.868.032l59.455-33.318c2.354-1.32 2.379-4.7.044-6.053l-59.495-34.493a6.97 6.97 0 0 0-7.029.023Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#CEE7FF",
    fillRule: "evenodd",
    d: "M167.773 75.173a3.45 3.45 0 0 0 1.781-3.042l.017 17.416a3.45 3.45 0 0 1-1.781 3.044v-.013l-.001.012-59.454 33.317v-.004a6.97 6.97 0 0 1-6.787-.076l-.017-17.418a6.97 6.97 0 0 0 6.868.031v.004l59.374-33.272v.011z",
    clipRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M169.554 72.13h.216a.216.216 0 1 0-.432 0zm-1.781 3.043-.105-.189a.22.22 0 0 0-.111.189zm1.798 14.374h-.217zm-1.781 3.044h-.216a.216.216 0 0 0 .322.188zm0-.013h.216a.216.216 0 0 0-.432-.012zm-.001.012.106.188a.22.22 0 0 0 .11-.177zm-59.454 33.317-.216.001a.217.217 0 0 0 .322.188zm0-.004h.216a.216.216 0 0 0-.319-.19zm-6.787-.076h-.216c0 .077.041.149.109.187zm-.017-17.418.108-.188a.216.216 0 0 0-.324.188zm6.868.031h.217a.22.22 0 0 0-.107-.186.22.22 0 0 0-.215-.002zm0 .004h-.216c0 .077.041.148.107.187a.22.22 0 0 0 .215.002zm59.374-33.272.216-.013a.217.217 0 0 0-.322-.176zm0 .011-.215.012a.216.216 0 0 0 .432-.013zm1.781-3.052h-.216a3.24 3.24 0 0 1-1.67 2.853l.105.189.106.188a3.67 3.67 0 0 0 1.891-3.23zm.017 17.416h.216l-.017-17.417h-.432l.016 17.417zm-1.781 3.044.106.188a3.67 3.67 0 0 0 1.891-3.232h-.433a3.23 3.23 0 0 1-1.67 2.855zm0-.013h-.216v.013h.432v-.014zm-.001.012.216.011.001-.012-.216-.011-.216-.012v.012zm-59.454 33.317.106.189 59.454-33.318-.106-.188-.105-.189-59.455 33.318zm0-.004h-.216v.005l.216-.001h.216v-.004zm0 0-.103-.19a6.75 6.75 0 0 1-6.577-.074l-.107.188-.107.187a7.18 7.18 0 0 0 6.997.079zm-6.787-.076h.216l-.016-17.418h-.433l.017 17.418zm-.017-17.418-.107.187a7.18 7.18 0 0 0 7.081.033l-.106-.189-.105-.188a6.75 6.75 0 0 1-6.655-.031zm6.868.031-.216.001v.003h.433v-.004zm59.374-33.268-.106-.189-59.373 33.272.105.189.106.189 59.373-33.273zm0 .011.216-.013v-.01l-.216.012-.216.012.001.011zm0-.01h-.216v.01h.433v-.01zm1.781-3.044h-.216v.002h.432v-.002z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#000",
    strokeWidth: 0.432,
    d: "m65.695 105.05-.016-17.238 10.92 6.138.017 17.377z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.432,
    d: "M131.204 47.332 65.717 87.857l15.047 8.81c12.598-5.25 15.505-16.206 25.467-19.903l35.749-22.752z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.432,
    d: "m79.07 47.799 65.447 40.277-16.175 9.36c-16.081-7.69-7.405-12.797-22.631-20.791L68.114 54.207z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#000",
    strokeWidth: 0.432,
    d: "m144.533 105.609-.016-17.238-10.909 6.158.016 17.378z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M135.066 117.438c-3.475.868-3.258-11.946-7.602-20.09 5.792 0 20.198 5.321 20.633 7.058.543 2.172 5.972 6.516 4.886 7.602s-13.574 4.344-17.917 5.43M72.081 112.551c-1.737.869-3.981-1.81-4.886-3.257l12.488-17.375c1.448.724 3.91 2.606 2.172 4.343-2.172 2.172-7.602 15.203-9.774 16.289"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B84FF",
    fillRule: "evenodd",
    d: "M115.628 45.18c-8.568 5.375-14.581 15.133-17.154 20.387l6.62 10.556c2.999-3.144 12.901-11.493 17.86-14.31 6.968-3.96 15.92-6.382 21.005-.406-6.156-7.664-6.781-10.718-7.206-12.8-.192-.935-.343-1.673-.936-2.546-3.923-5.77-11.289-6.463-20.189-.88",
    clipRule: "evenodd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#0863BF",
    d: "M139.671 73.107c4.377-2.707 7.035-8.281 4.288-11.7-5.085-5.976-14.037-3.554-21.005.405-4.959 2.818-14.861 11.167-17.86 14.31 4.664.542 15.847-.665 20.636-.019 5.986.807 9.83-.453 13.941-2.996"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.432,
    d: "M143.959 61.407c2.747 3.419.089 8.993-4.288 11.7-4.111 2.543-7.955 3.803-13.941 2.996-4.789-.646-15.972.56-20.636.02m38.865-14.716c-5.085-5.976-14.037-3.554-21.005.405-4.959 2.818-14.861 11.167-17.86 14.31m38.865-14.715c-6.156-7.664-6.781-10.718-7.206-12.8-.192-.935-.343-1.673-.936-2.546-3.923-5.77-11.289-6.463-20.189-.88-8.568 5.374-14.581 15.132-17.154 20.386l6.62 10.556"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m104.921 76.429 3.8-3.681c7.465-7.895-6.694-6.502-7.553-11.848-2.668 2.38-1.633 6.119-.782 7.69z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B84FF",
    fillRule: "evenodd",
    d: "M92.207 44.578c8.611 7.98 10.987 24.377 10.982 31.844l-4.992-2.127c-2.25-3.472-11.65-11.941-15.79-15.456-5.818-4.938-14.848-7.648-19.578-4.1 5.843-4.382 6.936-6.89 7.894-9.088.557-1.278 1.069-2.45 2.44-3.825 4.693-4.703 11.707-4.047 19.044 2.752",
    clipRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#0863BF",
    d: "M64.767 66.445c-3.614-3.308-5.28-9.2-1.938-11.706 4.73-3.548 13.76-.838 19.578 4.1 4.14 3.515 13.54 11.984 15.79 15.456-4.459-.32-16.323-2.334-20.918-2.578-5.743-.305-9.116-2.165-12.512-5.272"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.432,
    d: "M62.829 54.74c-3.341 2.505-1.676 8.397 1.938 11.705 3.396 3.107 6.769 4.967 12.512 5.272 4.595.244 16.459 2.258 20.918 2.578M62.829 54.74c4.73-3.548 13.76-.838 19.578 4.1 4.14 3.515 13.54 11.984 15.79 15.456M62.829 54.74c5.843-4.382 6.936-6.89 7.894-9.088.557-1.278 1.069-2.45 2.44-3.825 4.693-4.703 11.707-4.047 19.044 2.752 8.611 7.98 10.987 24.377 10.982 31.844l-4.992-2.127"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B84FF",
    stroke: "#000",
    strokeWidth: 0.432,
    d: "m64.171 113.537-18.689-9.68c-.959-.497-.992-1.866-.088-2.456 9.94-6.489 15.47-15.786 23.577-24.022 7.69-7.813 16.01-8.523 26.402-5.603 1.41.397 10.237 2.731 11.251 5.057-13.047-.704-19.842 11.836-26.16 20.41-3.543 4.811-9.088 12.092-13.42 15.979-.79.708-1.932.802-2.873.315Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B84FF",
    stroke: "#000",
    strokeWidth: 0.432,
    d: "m139.891 113.906 17.041-5.416c1.029-.327 1.294-1.672.509-2.413-7.448-7.03-10.828-15.77-16.538-23.987-5.473-7.875-12.947-10.37-22.339-9.39-1.275.132-10.932 1.943-12.151 3.798 11.353 1.326 17.463 12.686 21.638 21.014 2.31 4.607 5.941 11.572 9.071 15.594.65.836 1.76 1.121 2.769.8Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.827,
    d: "m40.945 49.836-3.355 1.767a9.49 9.49 0 0 0-4.768 10.764l.945 3.67c.143.55-.623.847-.887.343l-1.766-3.354a9.49 9.49 0 0 0-10.765-4.768l-3.67.945c-.55.143-.846-.623-.343-.887l3.354-1.767a9.49 9.49 0 0 0 4.768-10.764l-.945-3.67c-.143-.55.623-.846.888-.343l1.766 3.354a9.49 9.49 0 0 0 10.765 4.768l3.67-.945c.55-.143.846.623.343.887Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#CEE7FF",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.714,
    d: "m200.265 66.821-3.221-.575a8.195 8.195 0 0 0-8.957 4.806l-1.302 3.001c-.194.45-.872.246-.786-.237l.575-3.221a8.19 8.19 0 0 0-4.805-8.956l-3.002-1.303c-.45-.194-.246-.872.237-.786l3.222.575a8.194 8.194 0 0 0 8.956-4.805l1.302-3.002c.194-.45.873-.246.786.237l-.575 3.222a8.195 8.195 0 0 0 4.806 8.956l3.001 1.302c.451.194.246.873-.237.786Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.827,
    d: "m188.234 42.443-4.564-.559a11.514 11.514 0 0 0-12.195 7.433l-1.596 4.312c-.238.647-1.206.412-1.121-.273l.558-4.564a11.514 11.514 0 0 0-7.432-12.195L157.572 35c-.647-.237-.412-1.205.272-1.121l4.564.559a11.515 11.515 0 0 0 12.196-7.433l1.595-4.312c.238-.647 1.206-.412 1.122.273l-.559 4.564a11.514 11.514 0 0 0 7.432 12.195l4.312 1.596c.647.237.413 1.205-.272 1.12Z"
  })));
};
export default SvgRewardBox;